{"id":"ProductDetail.Details","prefabs":{"default":{"children":[{"component":"ProductDetail.Details","options":"options:*"}]}}}